<template>
    <div class="logo-on">
        <van-cell-group class="logo-cell-type">
            <van-field
                    v-model="name"
                    required
                    clearable
                    label="姓名"
                    placeholder="请输入真实姓名"
            />
            <van-field
                    v-model="idCard"
                    required
                    clearable
                    label="身份证号码"
                    placeholder="请输入身份证号码"
            />
            <!--图形验证码-->
            <pic-code ref="verificationCode"  @setVerificationStatus="getVerificationStatus"></pic-code>
        </van-cell-group>
        <button class="nextbtn" @click="nextTips">下一步</button>
        <div class="tips">
            <div class="tips-img tips-img-tel">
                <p>本服务由湖北省统一认证平台提供</p>
                <p>咨询服务热线:<span class="font36">12345</span></p>
            </div>
        </div>
        <div class="tips-type" v-show="tips">
            当前账号不存在！
        </div>
    </div>
</template>

<script>
    import { CellGroup, Field, Checkbox, Popup, Picker, Cell,Toast,Dialog} from 'vant'
    import PicCode from '@/components/verification-code-input/PicCode'
    import {memberApi} from '@/api/member';
    import { idCardRegex } from '@/utils/regex'
    export default {
        name: "forgetpasword",
        components: {
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Checkbox.name]: Checkbox,
            [Popup.name]: Popup,
            [Picker.name]: Picker,
            [Cell.name]: Cell,
            [Toast.name]: Toast,
            [Dialog.Component.name]:Dialog.Component,
            PicCode
        },
        data(){
            return{
                tips:false,
                verificationInfo:{},//图形验证码信息
                name:this.$route.query.name,
                idCard:this.$route.query.num,
            }
        },
        watch: {
            idCard(val){
                this.idCard = this.idCard.toUpperCase();
            }
        },
        mounted(){
            Toast.setDefaultOptions({ duration: 1500 });
        },
        methods:{
            async nextTips(){
                // this.tips=false;
                this.$refs.verificationCode.passValue();
                if (this.name === "") {
                    Toast.fail('请输入姓名');
                } else if (this.idCard === "") {
                    Toast.fail('请输入身份证号码');
                } else if(!idCardRegex(this.idCard)) {
                    Toast.fail('请输入正确的身份证号码');
                }else if(this.verificationInfo.verificationCode===undefined){
                    Toast.fail("请输入图形验证码")
                    return
                }else if(!this.verificationInfo.IsInputSuccStatus){
                    Toast.fail("请输入正确的图形验证码")
                    return
                } else {
                    Toast.loading({
                        duration: 0,       // 持续展示 toast
                        forbidClick: true, // 禁用背景点击
                        loadingType: 'spinner',
                        message: '校验中...'
                    })
                    let data={
                        name:this.name,
                        idCard:this.idCard.toUpperCase(),
                        verificationCode:this.verificationInfo.verificationCode,
                        verificationCodeGuid:this.verificationInfo.verificationCodeGuid,
                    }
                    try{
                        const res = await this.$httpUtils.postCommonUtils(memberApi.findPsdNew1, data);
                        Toast.clear()
                        console.log(res)
                        if(res.data.succ){
                            this.$router.push({path: '/sign-up/forget-password/det?idCard=' + this.idCard + '&phone=' + res.data.data.phone})
                            // Toast.success("密码重置成功")
                            // this.$router.push({path: '/sign-up/login'});

                        }else{
                            this.tips=true;
                            // Toast.fail("密码重置失败，"+res.data.message)
                            this.$refs.verificationCode.passValue();
                            this.$refs.verificationCode.interactionVerificationCode();
                        }
                    }catch (e) {
                        this.$refs.verificationCode.passValue();
                        this.$refs.verificationCode.interactionVerificationCode();
                        Toast.clear()
                        Toast.fail("服务功能不稳定，请稍后再试或前往鄂汇办APP进行密码更改！！！")
                        console.log(e)
                    }
                    // let data = {
                    //     name: this.name,
                    //     idCard: this.idCard.toUpperCase()
                    // }
                    // let _self = this;
                    // this.$httpUtils.postCommonUtils(memberApi.findPsdNew1, data).then((res) => {
                    //     Toast.clear()
                    //     if (res.data.succ) {
                    //         let result = res.data.data
                    //         this.$router.push({path: '/sign-up/forget-password/det?idCard=' + _self.idCard + '&phone=' + result.phone})
                    //     } else {
                    //         _self.tips=true;
                    //         setTimeout(()=>{
                    //             _self.tips=false
                    //         },1500)
                    //     }
                    // }).catch((error) => {
                    //     Toast.clear()
                    //     Toast.fail('服务器运行失败，请稍后再试。')
                    //     console.log(error)
                    // });
                }
            },
            //获取图形验证码
            getVerificationStatus(value){
                this.verificationInfo = value
            }
        }
    }
</script>

<style scoped>
    @import "~@assets/css/public/signup.css";

</style>
